import { z } from 'zod';
import { brandingSchema, brandLogoUploadSchema } from './marca.js';
import { entityCalendarSchema } from './calendario.js';
import { entityDetailsSchema } from './ficha.js';
/**
 * Lo que cambia en la suite y las apps deben volver a leer. La suite lo avisa con
 * `PATCH <provisioning_path>/:slug { changed: [...] }`; la app descarta su caché de eso (y si no entiende el aviso,
 * su caché vence sola: nunca más de 5 minutos).
 */
/** `keys`: la entidad cambió o rotó su llave (§3.16); la app olvida las que tiene en memoria. */
export const ENTITY_CHANGE_KEYS = ['details', 'branding', 'calendar', 'sources', 'mail', 'units', 'keys'];
/**
 * Traspaso único de lo que la app ya tenía de la entidad (`PUT /api/v1/service/entities/:slug/settings`): la suite
 * solo llena lo que aún no tiene; lo que la entidad ya configuró en la suite no se toca.
 */
export const entitySettingsImportSchema = z.object({
    details: entityDetailsSchema.optional(),
    branding: brandingSchema.optional(),
    logo: brandLogoUploadSchema.optional(),
    calendar: entityCalendarSchema.optional(),
});
/** Si la persona quiere el aviso de esa app también por correo. */
export function wantsEmail(prefs, appCode) {
    return prefs.emailNotifications && !prefs.emailMutedApps.includes(appCode);
}
//# sourceMappingURL=servicio.js.map